/**
 * Upsert a subscription row into an existing list by id. If the incoming row's id
 * matches one in the list, that row is replaced; otherwise, the row is inserted.
 * The result is always sorted by createdDate descending to match the existing list
 * convention in Subsriptions.tsx.
 *
 * Pure function — returns a new array on change, the same reference on no-op (incoming null).
 */
export const upsertSubscription = (existing: any[], incoming: any | null): any[] => {
    if (!incoming) return existing;
    const idx = existing.findIndex(s => s.id === incoming.id);
    const next = idx >= 0
        ? existing.map((s, i) => i === idx ? incoming : s)
        : [...existing, incoming];
    return next.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
};
